export class UfoAudio {
  private context:AudioContext|null=null;
  private master:GainNode|null=null;
  private engine:OscillatorNode|null=null;
  private muted=false;
  constructor(){try{this.muted=localStorage.getItem('ufo-muted')==='true';}catch{/* Storage is optional. */}}
  isMuted(){return this.muted;}
  unlock(){
    if(!this.context){
      this.context=new AudioContext();this.master=this.context.createGain();this.master.gain.value=this.muted?0:.35;this.master.connect(this.context.destination);
      this.engine=this.context.createOscillator();this.engine.type='sine';this.engine.frequency.value=64;
      const gain=this.context.createGain();gain.gain.value=.045;this.engine.connect(gain);gain.connect(this.master);this.engine.start();
    }
    void this.context.resume().catch(()=>undefined);
  }
  toggle(){this.muted=!this.muted;try{localStorage.setItem('ufo-muted',String(this.muted));}catch{/* optional */}if(this.master&&this.context)this.master.gain.setTargetAtTime(this.muted?0:.35,this.context.currentTime,.05);return this.muted;}
  pause(){void this.context?.suspend().catch(()=>undefined);}
  resume(){if(this.context)void this.context.resume().catch(()=>undefined);}
  play(kind:'start'|'route'|'correct'|'wrong'|'arrival'|'steer'|'star'|'asteroid'){
    if(!this.context||!this.master||this.muted)return;
    const step=kind==="star"?.06:.09;const notes=kind==='correct'?[523,659,784]:kind==='wrong'?[185,147]:kind==='arrival'?[392,523,659,784,1047]:kind==='start'?[262,392,523]:kind==='steer'?[330]:kind==='star'?[988,1319]:kind==='asteroid'?[110,82]:[440,660];
    notes.forEach((frequency,i)=>{const ctx=this.context!;const osc=ctx.createOscillator(),gain=ctx.createGain();const at=ctx.currentTime+i*step;
      osc.type=kind==='wrong'||kind==='asteroid'?'triangle':'sine';osc.frequency.setValueAtTime(frequency,at);osc.frequency.exponentialRampToValueAtTime(frequency*1.015,at+.2);
      gain.gain.setValueAtTime(0,at);gain.gain.linearRampToValueAtTime(kind==='steer'?.04:.13,at+.014);gain.gain.exponentialRampToValueAtTime(.001,at+.32);
      osc.connect(gain);gain.connect(this.master!);osc.start(at);osc.stop(at+.34);osc.onended=()=>{osc.disconnect();gain.disconnect();};
    });
  }
  dispose(){this.engine?.stop();this.engine?.disconnect();this.engine=null;void this.context?.close().catch(()=>undefined);this.context=null;this.master=null;}
}
